var mapAreasToOptions = function (areas) {
    return (areas === null || areas === void 0 ? void 0 : areas.map(function (_a) {
        var name = _a.name;
        return ({ label: name, value: name });
    })) || [];
};
export default mapAreasToOptions;
